module.exports = __webpack_public_path__ + "static/img/GettyImages-555084645.7dff838.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/GettyImages-555084645.jpg
// module id = rUwd
// module chunks = 0